export type RackLayerHeightMode = "clear" | "legacy-span";

export type RackLayerMetric = {
  cargoBaseY: number;
  clearBottomY: number;
  clearHeight: number;
  crossbarCenterY?: number;
};

export function createRackLayerMetrics(clearHeights: number[], crossbarHeight: number) {
  validateCrossbarHeight(crossbarHeight);
  let clearBottomY = 0;
  const layers = clearHeights.map((clearHeight, index): RackLayerMetric => {
    const hasCrossbarAbove = index < clearHeights.length - 1;
    const metric = {
      cargoBaseY: index === 0 ? 0 : clearBottomY - crossbarHeight / 2,
      clearBottomY,
      clearHeight,
      crossbarCenterY: hasCrossbarAbove
        ? clearBottomY + clearHeight + crossbarHeight / 2
        : undefined
    };
    clearBottomY += clearHeight + (hasCrossbarAbove ? crossbarHeight : 0);
    return metric;
  });
  return { layers, totalHeight: clearBottomY };
}

export function convertLegacyLayerSpansToClearHeights(
  layerSpans: number[],
  crossbarHeight: number
) {
  validateCrossbarHeight(crossbarHeight);
  if (layerSpans.length <= 1 || crossbarHeight === 0) {
    return [...layerSpans];
  }

  return layerSpans.map((span, index) => {
    const crossbarShare =
      index === 0 || index === layerSpans.length - 1 ? crossbarHeight / 2 : crossbarHeight;
    const clearHeight = span - crossbarShare;
    if (!Number.isFinite(clearHeight) || clearHeight <= 0) {
      throw new Error("旧项目层高小于横杆占用高度，无法转换为净层高");
    }
    return clearHeight;
  });
}

function validateCrossbarHeight(crossbarHeight: number) {
  if (!Number.isFinite(crossbarHeight) || crossbarHeight < 0) {
    throw new RangeError("crossbarHeight must be a non-negative finite number");
  }
}
